import {
    DigitalBusinessCard,
    DigitalBusinessCardBulkModel,
    DigitalBusinessCardTemplateModel
} from './digital-business-card.model';
import {DigitalBusinessCardSetting} from './digital-business-card-setting/digital-business-card-setting.model';
import {DBCCardTypes} from '../shared/utils';

export enum TYPOGRAPHY_CUSTOMIZATIONS {
    PERSONAL_INFO = 'personal_info',
    COMPANY_DETAILS = 'company_details',
    BIO = 'bio',
    CONTACT_DETAILS = 'contact_details',
    BUTTON = 'button',
}

export enum CONTACT_DETAIL {
    PHONE_V2 = 'phone_v2',
    EMAIL_V2 = 'email_v2',
    WEBSITE_V2 = 'website_v2',
    CUSTOM_FIELDS = 'custom_fields',
}

export enum ROUTES {
    EDIT_CARDS = '/digital-business-cards/my-cards/edit/',
    EDIT_TEAM_CARDS = '/digital-business-cards/team-cards/edit/'
}

export enum DBC_LAYOUTS {
    LAYOUT_1 = '1',
    LAYOUT_2 = '2',
    LAYOUT_3 = '3',
    LAYOUT_4 = '4',
    LAYOUT_5 = '5',
    LAYOUT_6 = '6',
    LAYOUT_7 = '7',
    LAYOUT_8 = '8',
    LAYOUT_9 = '9',
    LAYOUT_10 = '10',
    LAYOUT_11 = '11',
    LAYOUT_12 = '12',
}


export enum DBC_SHARE_SCREEN_SOURCE {
    MYCARDS = 'my_cards_page',
    OVERVIEW = 'overview_page',
}

export enum SHARE_TYPE {
    COPY_DBC_LINK_TO_CLIPBOARD = 'copy_dbc_link_to_clipboard',
    COPY_APPLE_WALLET_LINK_TO_CLIPBOARD = 'copy_apple_wallet_pass_link_to_clipboard',
    COPY_GOOGLE_WALLET_PASS_LINK_TO_CLIPBOARD = 'copy_google_wallet_pass_link_to_clipboard',
    DOWNLOAD_QR_CODE = 'download_qr_code',
    APPLE_WALLET_EMAIL_SENT = 'apple_wallet_email_sent',
    GOOGLE_WALLET_EMAIL_SENT = 'google_wallet_email_sent'
}

export enum MORE_OPTIONS_TYPES {
    EDIT_CARD = 'edit_card',
    VIEW_ANALYTICS = 'view_analytics',
    SHARE_WALLET_PASS = 'share_wallet_pass',
    DUPLICATE_CARD = 'duplicate_card',
    DELETE_CARD = 'delete_card',
}

export function getUserConsentAmplitudeValue(product: DigitalBusinessCard | DigitalBusinessCardBulkModel | DigitalBusinessCardTemplateModel) {
    if (product.lead_user_agreement) {
        product.lead_user_agreement_attribute.user_agreement_urls = product.lead_user_agreement_attribute.user_agreement_urls.filter(res => {
            return (res.url && res.label) ? res : null;
        });
        return product.lead_user_agreement_attribute.user_agreement_urls.length ? 'added' : 'not added';
    } else {
        return 'no';
    }
}

export function setLeadCollectionFieldChecks(leadSettings: any[], hasWriteAccess: boolean, cardSetting: DigitalBusinessCardSetting, cardType: DBCCardTypes, isSalesforceConnected: boolean) {
    leadSettings.forEach((setting: any) => {
        if (setting?.name === 'company') {
            setting['disable'] = !hasWriteAccess || (cardSetting.lead_collection && cardType !== DBCCardTypes.TEMPLATE_CARDS) || isSalesforceConnected;

            // If Sales-force is on set default value to true
            setting['default'] = isSalesforceConnected;
        }
    });

    return leadSettings;
}
export const auth0CustomParamsRegex = /^[-\w.*~@+ /:]{1,255}$/;
export const FOLLOW_UP_EMAIL_SUBJECT_DEFAULT = '<span class="fr-deletable fr-tribute" contenteditable="false">@ContactsFirstName</span>, <span class="fr-deletable fr-tribute" contenteditable="false">@MyFirstName</span> says "Hi! 👋"';
export const FOLLOW_UP_EMAIL_BODY_DEFAULT = '<p>It was a pleasure meeting you.</p><p>Thank you for viewing <span class="fr-deletable fr-tribute" contenteditable="false">@MyCardURL</span>&nbsp;and sharing your contact details with me.</p><p>Looking forward to staying connected!</p><p>Best,</p><p><span class="fr-deletable fr-tribute" contenteditable="false">@MyFullName</span>&nbsp;</p>';
export const maxSizeMB = 50;

export enum EVENT_SOURCE_MAPPING {
    'create-card-list-upsell' = '2nd_card_creation',
    'bulk_create_upsell_cta_clicked' = 'bulk_create',
    'bulk-create-upsell-cta-clicked' = 'bulk_create',
    'multilanguage-upsell' = 'multi_language_support',
    'custom-slug-cta' = 'url_domain',
    'unlock-more-designs-cta' = 'choose_card_design',
    'limitreached-adduser-upsell' = 'add_new_user',
    'integrations-zapier-upsell' = 'zapier',
    'integrations-google-analytics-upsell' = 'google_analytics',
    'integrations-google-ads-upsell' = 'google_ads',
    'integrations-active-directory-upsell' = 'microsoft_entra_id',
    'integrations-salesforce-upsell' = 'salesforce',
    'unlock-analytics-cta' = 'unlock_full_access_cta',
    'export-leads-source' = 'export_contacts',
    'view-all-leads-source' = 'upgrade_to_unlock',
    'customfont' = 'manage_custom_fonts',
    'sidenav-upgrade-cta' = 'upgrade_now_cta'
}
